import * as React from "react";
import type { SVGProps } from "react";
const SvgPlus03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M12 7.2v9.6m4.8-4.8H7.2"
    />
  </svg>
);
export default SvgPlus03;
